import type { LayoutProps } from '@chakra-ui/react';

export const COACH_PATH = '/coach';
export const COACH_NAV_BAR_HEIGHT = `calc(5rem + env(safe-area-inset-top))`;
export const COACH_FOOTER_HEIGHT = {
  base: `calc(env(safe-area-inset-bottom) + 15rem)`,
  lg: `calc(env(safe-area-inset-bottom) + 6rem)`,
} satisfies LayoutProps['h'];
